
import React from 'react';

export const BenefitsSection: React.FC = () => {
  const benefits = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Comprehensive Health Coverage',
      description: 'Full medical, dental, and vision insurance with premium coverage options for you and your family.'
    },
    {
      icon: 'ri-time-line',
      title: 'Flexible Work Arrangements',
      description: 'Remote work options, flexible hours, and work-life balance initiatives to support your lifestyle.'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Professional Development',
      description: 'Continuous learning opportunities, conference attendance, and skill development programs.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Competitive Compensation',
      description: 'Market-leading salaries, performance bonuses, and equity participation in company growth.'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Generous PTO Policy',
      description: 'Unlimited vacation policy, paid holidays, and sabbatical opportunities for long-term employees.'
    },
    {
      icon: 'ri-team-line',
      title: 'Collaborative Environment',
      description: 'Work with industry experts across diverse domains in a supportive, innovation-driven culture.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Why Join Our Team?</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We believe in investing in our people. Discover the comprehensive benefits and opportunities that make Business Development Authority an exceptional place to build your career.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center p-8 rounded-xl bg-gray-50 hover:bg-blue-50 transition-colors">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-600 text-white rounded-full mx-auto mb-6">
                <i className={`${benefit.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-8 lg:p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">Ready to Make an Impact?</h3>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Join our mission to drive business growth and innovation across multiple industry verticals. Your expertise can help shape the future of business development.
          </p>
          <button 
            onClick={() => document.getElementById('application')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            Start Your Application
          </button>
        </div>
      </div>
    </section>
  );
};
